export const TOKEN_MINUTE = 1000 * 60;
export const TOKEN_REFRESH_INTERVAL = 5 * TOKEN_MINUTE;
export const TOKEN_REFRESH_THRESHOLD = 25 * TOKEN_MINUTE;
export const ALERT_DURATION = 10000;

export enum ROLES {
  Admin = "admin",
  Owner = "owner",
  Member = "member",
  Moderator = "moderator",
}

export enum GradingMethod {
  MANUAL = "manual",
  AUTOMATIC = "automatic",
}

export enum Status {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
}

export enum Visibility {
  PRIVATE = "private",
  PUBLIC = "public",
  DISABLED = "disabled",
}

export enum SubmissionType {
  TEXT = "text",
  URL = "url",
  SHORT_TEXT = "short_text",
}
